export const SET_GOOD_LUCK_MESSAGES = 'SET_GOOD_LUCK_MESSAGES';